import MainLayout from "@/components/layout/admin/MainLayout.vue";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {
  required,
  maxLength,
  minValue
} from "vuelidate/lib/validators";
import axios from "axios";
import {isEnglishNumber, maxInteger8, decimalWithTwoPlaces} from "@/utils/validators";

export default {
  name: "adminCreate",
  components: {
    MainLayout,
    flatPickr,
  },

  data() {
    return {
      positionData: {
        position_name: '',
        description: '',
        basic_salary: '',
      },
      isError: false,
      submitted: false,
      disabled: false,
      positionExists: false,
    };
  },

  validations: {
    positionData: {
      position_name: {
        required,
        maxLength: maxLength(100)
      },
      description: {
        maxLength: maxLength(1000)
      },
      basic_salary: {
        isEnglishNumber,
        maxInteger8,
        decimalWithTwoPlaces,
        minValue: minValue(0)
      }
    }
  },

  methods: {
    confirmCreate() {
      if (this.disabled) return;
      this.submitted = true;
      this.disabled = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.disabled = false;
        return;
      }
      this.create();
    },

    create() {
      this.disabled = true;
      axios.post('position/create', this.positionData)
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Position Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: 'positionList'
            })
          } else {
            console.log(res.data);
            console.log("failed to add position");
            this.disabled = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          }
        }).catch((error) => {
          this.disabled = false;
          this.isLoading = false;
          if (error.response) {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            } else if (error.response.status == 422) {
              let errors = error.response.data.errors;
              if (errors.position_name[0]) {
                this.$notification.error(errors.position_name[0], {
                  timer: 3,
                  position: "bottomCenter",
                });
              }
            }
          }
        });
    },

    showList() {
      this.$router.push({
        name: "positionList"
      });
    },
  },
};
